import { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import api from "@/lib/api";

export default function EliteSpotlight() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/profile/spotlight").then((res) => setItems(res.data || [])).catch(() => setItems([]));
  }, []);
  if (!items.length) return null;
  return (
    <section data-testid="elite-spotlight-section" className="py-24 sm:py-32 bg-[#0a0a0a] border-y border-gold/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        <div className="text-center mb-12">
          <p className="text-xs font-body font-medium uppercase tracking-[0.2em] text-gold mb-3 inline-flex items-center gap-1.5">
            <Crown size={12} /> Elite Spotlight
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-white">
            Featured <span className="italic text-gold">Aristocrats</span>
          </h2>
          <p className="mt-3 text-white/50 font-body text-sm">Promotional videos from our Elite-tier creators</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.slice(0, 8).map((it) => (
            <div key={it.video_id} data-testid={`spotlight-${it.video_id}`} className="relative group border border-white/10 bg-white/[0.02] overflow-hidden">
              <video src={`${process.env.REACT_APP_BACKEND_URL}${it.url}`} muted loop playsInline
                onMouseEnter={(e) => e.currentTarget.play().catch(() => {})}
                onMouseLeave={(e) => { e.currentTarget.pause(); e.currentTarget.currentTime = 0; }}
                className="w-full aspect-[9/16] object-cover bg-black" />
              <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/80 to-transparent">
                <p className="text-gold text-[10px] font-body uppercase tracking-wider flex items-center gap-1">
                  <Crown size={10} /> Elite
                </p>
                <p className="text-white text-xs font-body truncate">{it.user_name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
